import { 
    IDENTITY_TYPE,
    SUBSCRIPTION_TYPE
} from './const';

export const shouldVerifyPersonalIdentity = (formData) => {
    return (formData.SubscriberType  == SUBSCRIPTION_TYPE.INDIVIDUAL
        && formData.BR_CR_PI_PN_Type == IDENTITY_TYPE.HKID)
}